module.exports = __webpack_public_path__ + "img/add_info.bf99771c.svg";